import type { StatusTone } from '../contracts/common';
import type { MeetingAiStatus, MeetingListWhen } from '../contracts/meetings';

/** Stan przetworzenia transkrypcji przez AI (DESIGN §2.5: AI pracuje / Gotowe / błąd z ponowieniem). */
export const MEETING_AI_STATUS_LABELS: Record<MeetingAiStatus, string> = {
  none: 'Nieprzetworzone',
  queued: 'AI pracuje',
  done: 'Gotowe',
  failed: 'Błąd AI',
};

export const MEETING_AI_STATUS_TONES: Record<MeetingAiStatus, StatusTone> = {
  none: 'neutral',
  queued: 'accent',
  done: 'success',
  failed: 'danger',
};

/** Przełącznik listy spotkań. */
export const MEETING_LIST_WHEN_LABELS: Record<MeetingListWhen, string> = {
  upcoming: 'Nadchodzące',
  past: 'Przeszłe',
  all: 'Wszystkie',
};

/** Stan propozycji zadania ze spotkania. */
export const MEETING_PROPOSAL_STATUS_LABELS: Record<'proposed' | 'accepted' | 'rejected', string> = {
  proposed: 'Do decyzji',
  accepted: 'Dodane',
  rejected: 'Odrzucone',
};

/** Odmiana: 1 propozycja, 2 propozycje, 5 propozycji (zadań). */
function pl(n: number, forms: readonly [string, string, string]): string {
  const abs = Math.abs(n);
  if (abs === 1) return forms[0];
  const lastTwo = abs % 100;
  const last = abs % 10;
  if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return forms[1];
  return forms[2];
}

/** „1 zadanie”, „2 zadania”, „5 zadań”. */
export function meetingTasksCount(n: number): string {
  return `${n} ${pl(n, ['zadanie', 'zadania', 'zadań'])}`;
}

/** „3 propozycje zadań ze spotkania „Warsztat”” (1: „1 propozycja zadania …”). Podsumowanie akceptacji. */
export function meetingProposalsSummary(n: number, title: string): string {
  const what = n === 1 ? 'propozycja zadania' : `${pl(n, ['propozycja', 'propozycje', 'propozycji'])} zadań`;
  return `${n} ${what} ze spotkania „${title}”`;
}

/** „1 propozycja do przejrzenia”, „3 propozycje do przejrzenia”. */
export function meetingPendingProposalsText(n: number): string {
  return `${n} ${pl(n, ['propozycja', 'propozycje', 'propozycji'])} do przejrzenia`;
}
